<!--
 * @Author: zhangzhian
 * @Date: 2023-06-06 15:17:08
 * @LastEditors: zhangzhian
 * @LastEditTime: 2023-06-06 17:28:28
 * @FilePath: \dhr_frontend\src\components\ExportBtn\index.vue
 * @ImportRoute: import ExportBtn from '@/components/ExportBtn/index'
 * @Description: 导出按钮
-->
<template>
  <a-button
    class="export-btn"
    :loading="exportLoading"
    @click="
      exportDownLoad({
        url: exportUrl,
        params: exportParams,
        ...exportDownLoadOptions
      })
    "
    >
      <slot>导出</slot>
    </a-button>
</template>
<script>
import exportMixin from '@/mixins/export';
export default {
  name: 'export-btn',
  mixins: [exportMixin],
  components: {},
  props: {
    exportUrl: {
      type: String,
      default: ''
    },
    exportParams: {
      type: Object,
      default: () => ({})
    },
    // 导出下载方法选项
    exportDownLoadOptions: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.export-btn {
}
</style>
